import { render } from "./UltraColText.vue?vue&type=template&id=686fb0f2"
import script from "./UltraColText.vue?vue&type=script&lang=js"
export * from "./UltraColText.vue?vue&type=script&lang=js"

import exportComponent from "/mnt/dados/Projects/softline-infinity-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__